import { coerceNumberProperty, NumberInput } from '@angular/cdk/coercion';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostBinding,
  Input,
} from '@angular/core';
import { isThemeColor, ThemeColor } from '../../../types/theme';

import { ThemeColorService } from '../../services';

@Directive({
    selector: '[luiAvatar]',
    standalone: false
})
export class AvatarDirective implements AfterViewInit {
  private _model = 'avatar';

  @HostBinding('class') get classNames() {
    return {
      [this._model]: true,
      ...this.themeColorService.generateClasses(this._model, this.color),
    };
  }

  @Input() get color(): ThemeColor | 'default' {
    return this._color;
  }
  set color(value: string) {
    if (isThemeColor(value) || value === 'default') {
      this._color = value;
    }
  }
  private _color: ThemeColor | 'default' = 'default';

  @Input() get size(): NumberInput {
    return this._size;
  }
  set size(value: NumberInput) {
    this._size = coerceNumberProperty(value);
    this._setSizeCssVariable();
  }
  private _size = 64;

  get sizeCssVariable() {
    return `${this._size}px`;
  }

  constructor(
    private elementRef: ElementRef,
    private themeColorService: ThemeColorService
  ) {}

  ngAfterViewInit(): void {
    this._setSizeCssVariable();
  }

  private _setSizeCssVariable() {
    this.elementRef.nativeElement.style.setProperty(
      '--size',
      this.sizeCssVariable
    );
  }
}
